import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {cartAtom} from 'store';
import {useSetRecoilState} from 'recoil';
import {onRemoveCartRes} from './helper';

const removeCart = async () => axios.delete(Routes.REMOVE_CART);

export const useRemoveCart = () => {
  const setCart = useSetRecoilState(cartAtom);

  return useMutation({
    mutationKey: [Keys.REMOVE_CART_MUT],
    mutationFn: removeCart,
    onSuccess: () => onRemoveCartRes({cart: null, setCart}),
  });
};
